import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { PortalStatus } from '../status';
import { PortalStatusBadge } from './PortalStatusBadge';

interface PortalListRowProps {
  to: string;
  /** e.g. "Quote EST-0042" */
  title: string;
  /** e.g. "8 Sep 2026" */
  date?: string | null;
  /** One line under the title (truncated) */
  description?: string | null;
  status: PortalStatus;
}

/** number · date / one-line description / status badge — the only list row in the portal. */
export function PortalListRow({ to, title, date, description, status }: PortalListRowProps) {
  return (
    <Link
      to={to}
      className="flex items-center gap-3 rounded-lg border bg-card px-4 py-3 transition-colors hover:bg-muted/50"
    >
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium">
          {title}
          {date && <span className="font-normal text-muted-foreground"> · {date}</span>}
        </p>
        {description && <p className="truncate text-sm text-muted-foreground">{description}</p>}
      </div>
      <PortalStatusBadge status={status} className="shrink-0" />
      <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
    </Link>
  );
}
